import React from "react";
import "./About.css";

function About() {

return (
<div className="about-page">

{/* HERO */}
<section className="about-hero">
  <h1>About Tejase Traders</h1>
  <p>
    Building trust in global agricultural trade through quality and consistency
  </p>
</section>


{/* STORY */}
<section className="company-intro">
  <h2>Our Story</h2>

  <p>
    Tejase Traders Private Limited was established with a clear goal — to
    simplify and strengthen the export of agricultural and poultry products
    to international markets.
  </p>

  <p>
    We focus on delivering products that meet expectations, maintaining
    consistency in supply, and building long-term business relationships.
  </p>
</section>



{/* CORE VALUES */}
<section className="feature-grid">

  <div className="feature-card">
    <div className="icon">🌱</div>
    <h3>Quality First</h3>
    <p>Every product is selected with attention to quality and reliability.</p>
  </div>

  <div className="feature-card">
    <div className="icon">🌍</div>
    <h3>Global Mindset</h3>
    <p>We operate with a focus on international standards and expectations.</p>
  </div>

  <div className="feature-card">
    <div className="icon">📈</div>
    <h3>Growth Focus</h3>
    <p>We continuously improve our operations to serve clients better.</p>
  </div>

  <div className="feature-card">
    <div className="icon">🤝</div>
    <h3>Trust & Transparency</h3>
    <p>We believe in honest communication and long-term partnerships.</p>
  </div>

</section>



{/* WHAT MAKES US DIFFERENT */}
<section className="why-us">

  <div className="left-box">

    <div className="info-card">
      <h2>Clear Communication</h2>
      <p>
        We ensure every client stays informed throughout the process,
        creating confidence and clarity.
      </p>
    </div>

    <div className="info-card">
      <h2>Reliable Execution</h2>
      <p>
        Orders are handled with responsibility and attention to detail,
        ensuring smooth delivery.
      </p>
    </div>

    <div className="info-card">
      <h2>Flexible Approach</h2>
      <p>
        We adapt based on client requirements and market needs.
      </p>
    </div>

  </div>


  <div className="right-box">

    <div className="mini-card">🌱 Quality Driven</div>
    <div className="mini-card">🌍 Global Focus</div>
    <div className="mini-card">📈 Continuous Growth</div>
    <div className="mini-card">🤝 Strong Relationships</div>

  </div>

</section>



{/* FINAL MESSAGE */}
<section className="about-stats">

  <div className="export-text">
    <h3>Our Commitment</h3>
    <p>
      At Tejase Traders, we are committed to delivering value through
      consistency, trust, and long-term partnerships. Our aim is not just
      to supply products, but to build a dependable global presence.
    </p>
  </div>

</section>


</div>
);
}

export default About;